export default "__VITE_ASSET__CWuo17Fa__"